import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { package as PackagePropType } from 'lib/CustomPropTypes';
import { PackageTitleTopBorder } from '../../PackageTitleTopBorder/index';

export class TeaseListContainer extends React.Component {
  static propTypes = {
    ad: PropTypes.node,
    children: PropTypes.node.isRequired,
    content: PackagePropType.isRequired,
    pkgClassName: PropTypes.string,
    vertical: PropTypes.string.isRequired,
    route: PropTypes.string.isRequired,
    className: PropTypes.string,
  };

  static defaultProps = {
    ad: null,
    pkgClassName: '',
    className: '',
  };

  getConditionalTitleClasses = () => {
    const { vertical, route } = this.props;

    if ((vertical === 'news' || vertical === 'noticias') && route === '/') {
      return 'hideNewsTitle';
    }

    return 'showNewsTitle';
  };

  renderInfoButton = () => (
    <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg" className="absolute">
      <path fillRule="evenodd" clipRule="evenodd" d="M6.5 12.1522C9.62161 12.1522 12.1522 9.62161 12.1522 6.5C12.1522 3.37839 9.62161 0.847826 6.5 0.847826C3.37839 0.847826 0.847826 3.37839 0.847826 6.5C0.847826 9.62161 3.37839 12.1522 6.5 12.1522ZM6.5 13C10.0899 13 13 10.0899 13 6.5C13 2.91015 10.0899 0 6.5 0C2.91015 0 0 2.91015 0 6.5C0 10.0899 2.91015 13 6.5 13Z" fill="black" fillOpacity="0.8" />
      <path d="M6.59942 4.23999C7.03181 4.23999 7.37772 3.90369 7.37772 3.50012C7.37772 3.07734 7.03181 2.76025 6.59942 2.76025C6.14781 2.76025 5.8019 3.07734 5.8019 3.50012C5.8019 3.90369 6.14781 4.23999 6.59942 4.23999ZM5.37912 9.89135H7.92542V9.36708H7.58594C7.3265 9.30943 7.29125 9.36287 7.29125 8.94009L7.30085 6.31628C7.30085 5.58602 7.36812 5.2305 7.37772 5.07676L7.25281 4.99989L5.37912 5.21128L5.38872 5.75995H5.72503C5.98446 5.91369 6.03251 5.86467 6.03251 6.26824L6.0229 8.94009C6.0229 9.34365 5.97485 9.29982 5.71542 9.36708H5.36951L5.37912 9.89135Z" fill="black" fillOpacity="0.8" />
    </svg>
  );

  renderHeadline = () => {
    const { content } = this.props;
    const {
      metadata: { title, logoUrl },
    } = content;
    return (
      <PackageTitleTopBorder
        title={title}
        logoUrl={logoUrl}
        additionalClasses="tease-list__list-title"
      />
    );
  }

  render() {
    const {
      ad,
      children,
      pkgClassName,
      content,
      className: additionalClasses,
    } = this.props;

    const {
      id,
      metadata: { title },
      adAboveList,
    } = content;

    return (
      <section
        data-packageid={id}
        className={classNames(
          'tease-list',
          pkgClassName,
          additionalClasses,
          {
            'tease-list__has-list-title': !!title,
          },
        )}
      >
        <div
          data-test="teaseList__wrapper"
          className={classNames(
            'tease-list__wrapper',
            this.getConditionalTitleClasses(),
          )}
        >
          {adAboveList && ad}
          {this.renderHeadline()}
          {children}
          {!adAboveList && ad}
        </div>
      </section>
    );
  }
}

export const TeaseListItemContainer = ({ children, itemClasses, itemId }) => (
  <li
    data-contentid={itemId}
    className={classNames(itemClasses, 'tease-list__item')}
  >
    {children}
  </li>
);

TeaseListItemContainer.propTypes = {
  children: PropTypes.node.isRequired,
  itemId: PropTypes.string.isRequired,
  itemClasses: PropTypes.string,
};

TeaseListItemContainer.defaultProps = {
  itemClasses: '',
};
